import { render, staticRenderFns } from "./HubHeader.vue?vue&type=template&id=67f0c9e3&"
import script from "./HubHeader.vue?vue&type=script&lang=js&"
export * from "./HubHeader.vue?vue&type=script&lang=js&"
import style0 from "./HubHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports